// eslint-disable-next-line import/no-extraneous-dependencies
import { getCookieName } from '@amplitude/analytics-core'

const amplitudeExperimentsIds = {
  prod: {
    CRO_TON_047: 'prod-teste-ton-elasticidade-valor-de-adesao-cro-ton-047',
    CRO_TON_057: 'prod-teste-ton-c2wpp-site-flows-cro-ton-057'
  },
  dev: {
    CRO_TON_047: 'sdx-teste-ton-elasticidade-valor-de-adesao-cro-ton-047',
    CRO_TON_057: 'sdx-teste-ton-c2wpp-site-flows-cro-ton-057'
  }
} as const

const amplitudeFlagsIds = {
  prod: {
    FLAG_TON_WHATSAPP_AND_CHAT_WIDGET: 'flag-ton-widget-whatsapp'
  },
  dev: {
    FLAG_TON_WHATSAPP_AND_CHAT_WIDGET: 'flag-ton-widget-whatsapp'
  }
} as const

const environment =
  process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === 'development' ? 'dev' : 'prod'

const TESTS = amplitudeExperimentsIds[environment]

const FLAGS = amplitudeFlagsIds[environment]

const AMPLITUDE = { TESTS, FLAGS }

export const AMPLITUDE_COOKIE_KEY = getCookieName(
  process.env.NEXT_PUBLIC_AMPLITUDE_ANALYTICS_API_KEY || ''
)

export default AMPLITUDE
